'use client'

import Image from 'next/image'

import { LoginForm } from '~/components/LoginForm'
import { useIsStandalone } from '~/hooks/useIsStandalone'

/**
 * Use with withAuthentication to display a message when the user is not authenticated.
 * Designed to take up the full width of the page.
 */
export function UnauthenticatedPage() {
  const isStandalone = useIsStandalone()

  return (
    <div className="flex min-h-dvh w-full justify-center overflow-auto bg-surface px-5 pt-24 md:items-center md:p-12">
      <div className="w-full max-w-sm space-y-8">
        <div className="flex items-center gap-2">
          <Image
            src="/logo_light.svg"
            alt="Splits logo"
            width={40}
            height={40}
            className="block dark:hidden"
          />
          <Image
            src="/logo_dark.svg"
            alt="Splits logo"
            width={40}
            height={40}
            className="hidden dark:block"
          />
          <span className="text-xl font-semibold text-gray-900 dark:text-white">
            Splits
          </span>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl">You are signed out</h1>
          <p className="text-sm text-secondary">
            Access to this page requires you to be signed in.
          </p>
        </div>

        <LoginForm />

        {isStandalone && (
          <p className="text-sm text-secondary">
            Don&apos;t have an account? Open <strong>app.splits.org</strong> in
            your browser to create one.
          </p>
        )}
      </div>
    </div>
  )
}
